
import { connect } from 'react-redux';
import { changeVolume, toggleMuteVolume } from '../actions/VolumeActions';
import Volume from '../components/VolumeComponent';

const mapStateToProps = (state) => ({
    volume: state.aovivoBar.Volume.volume,
    isMobile: state.clientInfo.isMobile,
});

const mapDispatchToProps = (dispatch) => ({
    toggleMuteVolume: () => {
        dispatch(toggleMuteVolume());
    },
    changeVolume: (volume) => {
        dispatch(changeVolume(volume));
    },
});

const VolumeContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Volume);

export default VolumeContainer;
